import apiFetch from './fetch';
export default apiFetch;

export * from './utils';

export interface APIResponse<P = any> {
  status: number;
  body: P;
}
